module.exports = __webpack_public_path__ + "img/sports-volleyball_white.f2217b69.svg";